import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { detectBody } from '../../app.helpers';
import { AppInformationService } from '../../core/core.module';
import { NavigationComponent } from '../navigation/navigation.component';
import { TopNavbarComponent } from '../topnavbar/topnavbar.component';

declare var jQuery: any;

@Component({
    selector: 'app-basic',
    templateUrl: 'basicLayout.template.html',
    imports: [CommonModule, RouterOutlet, DevExtremeModule, NavigationComponent, TopNavbarComponent],
    standalone: true,
})
export class BasicLayoutComponent implements OnInit {
    window: any;
    church: string;

    constructor(private appInfo: AppInformationService) {}

    public ngOnInit() {
        this.church = this.appInfo.settings.church;
        detectBody();
    }

    pleaseWait() {
        return !!this.appInfo && this.appInfo.pleaseWait;
    }

    @HostListener('window:resize')
    public onResize() {
        console.log('onResize');
        detectBody();
    }
}
